import { render } from "./BackTop.vue?vue&type=template&id=4ad732d9&scoped=true"
import script from "./BackTop.vue?vue&type=script&lang=js"
export * from "./BackTop.vue?vue&type=script&lang=js"

import "./BackTop.vue?vue&type=style&index=0&id=4ad732d9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ad732d9"

export default script